export default __webpack_public_path__ + "static/media/ic_resale.12577bc2.svg";